export const IMAGES = [
  {
    src: "https://i.ibb.co/4WHWW9L/1.jpg",
    thumbnail: "https://i.ibb.co/4WHWW9L/1.jpg",
  },
  {
    src: "https://i.ibb.co/CJLgvc9/00.jpg",
    thumbnail: "https://i.ibb.co/CJLgvc9/00.jpg",
  },
  {
    src: "https://i.ibb.co/W2R8HVj/2.jpg",
    thumbnail: "https://i.ibb.co/W2R8HVj/2.jpg",
  },
  {
    src: "https://i.ibb.co/0rJ2Kq0/3.jpg",
    thumbnail: "https://i.ibb.co/0rJ2Kq0/3.jpg",
  },
  {
    src: "https://i.ibb.co/y4Zhzbr/4.jpg",
    thumbnail: "https://i.ibb.co/y4Zhzbr/4.jpg",
  },
  {
    src: "https://i.ibb.co/tzZ9htm/5.jpg",
    thumbnail: "https://i.ibb.co/tzZ9htm/5.jpg",
  },
  {
    src: "https://i.ibb.co/k2tKB2Q/6.jpg",
    thumbnail: "https://i.ibb.co/k2tKB2Q/6.jpg",
  },
  {
    src: "https://i.ibb.co/VpCng5d/7.jpg",
    thumbnail: "https://i.ibb.co/VpCng5d/7.jpg",
  },
  {
    src: "https://i.ibb.co/jf7Qk7W/9.jpg",
    thumbnail: "https://i.ibb.co/jf7Qk7W/9.jpg",
  },
  {
    src: "https://i.ibb.co/6sY2Kf3/8.jpg",
    thumbnail: "https://i.ibb.co/6sY2Kf3/8.jpg",
  },

  {
    src: "https://i.ibb.co/FYFgBc1/IMG-1029-1.jpg",
    thumbnail: "https://i.ibb.co/FYFgBc1/IMG-1029-1.jpg",
  },

  {
    src: "https://i.ibb.co/wM6Y4ZM/IMG-1021.jpg",
    thumbnail: "https://i.ibb.co/wM6Y4ZM/IMG-1021.jpg",
  },
 
  { src: "https://i.ibb.co/QH4ydkz/IMG-20240406-143451.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/K76tK6q/IMG-20240406-143521.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/ThPrYCj/lab-301-pic2.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/YDxf598/lab-301-pic1.jpg", thumbnail: "" },
];
